export default new class ParamsLocalStorage {
  constructor() {
    this.localConst = 'book24Params';
  }

  /**
   * Возвращает сохраненные данные клиента
   * @returns {any|{}}
   */
  getLocalStorage() {
    if (navigator.cookieEnabled) {
      return JSON.parse(localStorage.getItem(this.localConst)) || {};
    }
    return {};
  }

  /**
   * Возвращает сохраненные данные клиента по ключу
   * @param {string} paramName - Имя ключа в котором брать данные
   * @returns {*}
   */
  getLocalItem(paramName) {
    const localParams = this.getLocalStorage();
    return localParams[paramName];
  }

  /**
   * Устанавливает параметры пользователя
   * @param {string} paramName - Имя ключа в котором сохранять данные
   * @param {any} obj - Данные для сохранения
   */
  setLocalItem(paramName, obj) {
    if (navigator.cookieEnabled) {
      const localParams = this.getLocalStorage();
      localParams[paramName] = obj;
      localStorage.setItem(this.localConst, JSON.stringify(localParams));
    }
  }

  /**
   * Удаляет параметр пользователя
   * @param {string} paramName - Имя ключа для удаления данных
   */
  deleteLocalItem(paramName) {
    if (navigator.cookieEnabled) {
      const localParams = this.getLocalStorage();
      delete localParams[paramName];
      localStorage.setItem(this.localConst, JSON.stringify(localParams));
    }
  }
}();
